import { cellRenderParseData } from '../../../utils/functions';

/** Список полей */
const columnDataGrid = [
  {
    dataField: 'contractNumberSys',
    dataType: 'string',
    caption: '№ договора (системный)'
  },
  {
    dataField: 'contractNumberLog',
    dataType: 'string',
    caption: '№ договора (логический)'
  },
  {
    dataField: 'contractDate',
    dataType: 'date',
    caption: 'Дата договора',
    cellRender: cellRenderParseData
  }
];

export default columnDataGrid;
